import React from "react";
import "./HomeLandingPage.scss";
import AppIcon from "../../assets/icons/AppIcon.svg";
import Play_Store from "../../assets/icons/Play_Store.svg";
import App_Store from "../../assets/icons/App_Store.svg";
import { ApiConnection } from "../../config/env";
const HomeLandingPage = () => {
  return (
    <div className="Container">
      {/* Link Section */}
      <div className="LinkSection">
        <div className="SectionContainer">
          {/* Logo Section */}
          <div className="IconContainer_logo">
            <img className="Icon" src={AppIcon} alt="ZAI BIDS" />
            <h2>ZAI BIDS</h2>
          </div>

          {/* Download Links Section */}
          <div className="LinkWrapper">
            <h3>Download it from the Play Store or App Store.</h3>
            <div className="LinkContainer">
              {/* Play Store Button */}
              <div
                className="PlayStoreSection"
                onClick={() => window.open("https://play.google.com/", "_blank")}
              >
                <div className="IconContainer">
                  <img className="Icon_Store" src={Play_Store} alt="Play Store" />
                  <h2>Play Store</h2>
                </div>
              </div>

              {/* App Store Button */}
              <div
                className="AppStoreSection"
                onClick={() => window.open("https://www.apple.com/in/store", "_blank")}
              >
                <div className="IconContainer">
                  <img className="Icon_Store" src={App_Store} alt="App Store" />
                  <h2>App Store</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="AboutSection">
        <h1>ABOUT US</h1>
        <p>
          ZAI BIDS is a registered trademark.
          <br />
          ZAI BIDS is a marketplace app where contractors and customers meet.
          Registration is free and easy. Customers post their projects such as
          painting, roofing, remodeling, etc. with pictures and specifications
          attached. Then, multiple contractors will place bids for the project.
          Afterwards, the customer awards the project to a selected business. The
          business pays a small fee to ZAI BIDS, and we will release the
          customer’s phone number and address to the contractor; otherwise, the
          customer’s information stays fully confidential.
          ZAI BIDS values your privacy as our customer.
        </p>
      </div>

      {/* Footer Section */}
      <div className="FooterSection">
        <footer className="bg-gray-900 text-white py-2 px-0">
          <div className="container_footer mx-auto flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-white ">
              &copy;{new Date().getFullYear()} ZAI BIDS. All rights reserved.
              <a
                href="mailto:support@zaibids.com"
                className="Support_Mail hover:underline ml-7"
              >
                support@zaibids.com
              </a>
            </p>
            <nav className="flex space-x-4 mt-6 md:mt-0">
              <a href="/" className="hover:underline">
                About
              </a>
              <a href="mailto:support@zaibids.com" className="hover:underline">
                Contact
              </a>
             <a href={`${ApiConnection.BACKEND_URL}/upload/privacyPolicy`} className="hover:underline"> Privacy Policy</a>
            </nav>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default HomeLandingPage;
